/**
 * RepaymentFrequencyInput
 *
 * Atomic component for Repayment Frequency selection (EMI/EDI/EWI).
 * Component ID: LOS_RepaymentFrequencyInput_436
 * Getter API: LOS_GetRepaymentFrequency_437
 * Setter API: LOS_SetRepaymentFrequency_438
 */

import React, { useCallback } from 'react';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

interface RepaymentFrequencyInputProps {
  value?: { repayment_frequency?: string };
  onChange?: (value: { repayment_frequency: string }) => void;
  disabled?: boolean;
}

const RepaymentFrequencyInput: React.FC<RepaymentFrequencyInputProps> = ({
  value,
  onChange,
  disabled = true  // Always disabled - value comes from backend
}) => {
  const currentValue = value?.repayment_frequency || 'EMI';

  const handleChange = useCallback((frequency: string) => {
    // Component is always disabled, don't trigger onChange
    return;
  }, []);

  const frequencies = [
    {
      value: 'EMI',
      label: 'EMI (Monthly Installment)',
      description: 'Pay a fixed amount every month'
    },
    {
      value: 'EDI',
      label: 'EDI (Daily Repayment)',
      description: ''
    },
    {
      value: 'EWI',
      label: 'EWI (Weekly Installment)',
      description: 'Pay a fixed amount every week'
    }
  ];

  return (
    <div className="space-y-1.5">
      <Label htmlFor="repayment-frequency" className="text-sm font-medium">
        Repayment Frequency <span className="text-red-500">*</span>
      </Label>
      
      <Select value={currentValue} onValueChange={handleChange} disabled={true}>
        <SelectTrigger id="repayment-frequency" className="w-full text-intellend-green !font-bold [&>span]:text-intellend-green [&>span]:!font-bold disabled:text-intellend-green disabled:opacity-100 [&>span]:disabled:text-intellend-green">
          <SelectValue placeholder="Select repayment frequency" />
        </SelectTrigger>
        <SelectContent>
          {frequencies.map((frequency) => (
            <SelectItem key={frequency.value} value={frequency.value}>
              <div className="flex flex-col">
                <span className="font-medium">{frequency.label}</span>
                <span className="text-xs text-gray-500">{frequency.description}</span>
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default RepaymentFrequencyInput;
